module.exports = __webpack_public_path__ + "img/align-justify-solid.9f8fc9a1.svg";